import { motion } from "framer-motion";
import androidLogo from "@assets/images/android-logo.avif";
import iosLogo from "@assets/images/ios-logo.avif";
import CardComponent from "./CardComponent";

export const AppDevelopmentSolutions = () => {
  return (
    <section className="space-y-20 md:space-y-32 ">
      <section className="   space-y-14 ">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
          className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px]  text-center   font-bold text-dark font-butler"
        >
          Mobile App Development Solutions{" "} 
        </motion.h2>

        <div className="space-y-10 bg-gray-50 py-14 ">
          <motion.h3
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[22px] md:text-[28px] lg:text-[35px] xl:text-[40px] 2xl:text-[40px] leading-[1.2]  text-center  font-bold text-dark font-butler"
          >
            Platform Native Development 
          </motion.h3>
<CardComponent  range = {[0,2]} gridValue={2}/>
           
        </div>
<CardComponent  range = {[-4]} gridValue={2}/>
      </section>
    </section>
  );
};
